var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRakutenPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color,
    fillRule: "nonzero"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.055 10.29H12.78v11.804h2.25v-3.81h2.024a3.998 3.998 0 100-7.995v.001zm-.15 5.895H15.03v-3.796h1.875a1.808 1.808 0 011.815 1.875 1.846 1.846 0 01-1.815 1.92z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14A14 14 0 0016 2zm0 26C9.373 28 4 22.627 4 16S9.373 4 16 4s12 5.373 12 12c-.008 6.624-5.376 11.992-12 12z"
  })))));
}

export default SvgIconRakutenPoints;